import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from "@angular/common/http";
import {Observable} from "rxjs";
import {CustomerActionModel} from "../../dto/customerActionModel";

@Injectable({
  providedIn: 'root'
})
export class CustomerActionService {
  readonly apiPath = 'customer-action/';
  readonly headers = new HttpHeaders({ 'No-Auth': 'True' });
  constructor(
    private http: HttpClient,
  ) { }


  getLinkAction(token: string): Observable<CustomerActionModel> {

    const params = new HttpParams()
      .set('token', token)
      ;

    return this.http.get(this.apiPath, {params, headers: this.headers}) as Observable<CustomerActionModel>;
  }

  confirmAction(token: string): Observable<CustomerActionModel> {

    const params = new HttpParams()
      .set('token', token)
    ;

    return this.http.post(this.apiPath + "confirm-action", {confirm: 1}, {params, headers: this.headers}) as Observable<CustomerActionModel>;
  }

  denyAction(token: string): Observable<CustomerActionModel> {

    const params = new HttpParams()
      .set('token', token)
    ;

    return this.http.post(this.apiPath + "deny-action", {confirm: 0}, {params, headers: this.headers}) as Observable<CustomerActionModel>;
  }

}
